import { render, staticRenderFns } from "./Moabouts.vue?vue&type=template&id=c50dd49e&scoped=true&"
import script from "./Moabouts.vue?vue&type=script&lang=js&"
export * from "./Moabouts.vue?vue&type=script&lang=js&"
import style0 from "./Moabouts.vue?vue&type=style&index=0&id=c50dd49e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50dd49e",
  null
  
)

export default component.exports